import React, { useEffect } from 'react'
import { initializeNostoSessionParams, nostoSessionParams } from '@stores/nostoSessionStore'

const NostoSessionInit = () => {
    useEffect(() => {
        // Wait for Nosto to be available
        const waitForNosto = () => {
            return new Promise((resolve) => {
                if (window.nostojs) {
                    resolve()
                } else {
                    const checkInterval = setInterval(() => {
                        if (window.nostojs) {
                            clearInterval(checkInterval)
                            resolve()
                        }
                    }, 100)

                    // Add timeout to prevent hanging
                    setTimeout(() => {
                        clearInterval(checkInterval)
                        console.log('🔍 NostoSessionInit - Timeout waiting for nostojs, proceeding without session params');
                        resolve()
                    }, 5000) // 5 second timeout
                }
            })
        }

        const initSession = async () => {
            try {
                await waitForNosto()
                await initializeNostoSessionParams()

                // Also save to cookie for server-side access
                const params = nostoSessionParams.get()
                if (params) {
                    const cookieValue = encodeURIComponent(JSON.stringify(params))
                    document.cookie = `nosto_session_params=${cookieValue}; path=/; max-age=3600; SameSite=Lax`
                    console.log('🔍 NostoSessionInit - Session initialized successfully with params:', params)
                } else {
                    console.log('🔍 NostoSessionInit - Session initialized but no params available')
                }
            } catch (error) {
                console.error('Error initializing Nosto session:', error)
            }
        }

        initSession()
    }, [])

    return null // This component doesn't render anything
}

export default NostoSessionInit
